
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis-circle\" ><title>ellipsis-circle-cp</title><g fill-rule=\"evenodd\"><path d=\"M22.13.109C10.049.109.255 9.903.255 21.984s9.794 21.875 21.875 21.875 21.875-9.794 21.875-21.875S34.211.109 22.13.109zm0 40.7c-10.396 0-18.825-8.429-18.825-18.825 0-10.396 8.429-18.825 18.825-18.825 10.396 0 18.825 8.429 18.825 18.825 0 10.396-8.429 18.825-18.825 18.825z\"/><circle cx=\"21.888\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"12.23\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"31.546\" cy=\"22.701\" r=\"2.445\"/></g></symbol>";
module.exports = sprite.add(image, "ellipsis-circle");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/ellipsis-circle.svg
// module id = 487
// module chunks = 0 1